import { Notification } from 'entities/notification/model/types'
import { FC } from 'react';
import NotificationItem from '../Notification/Notification';
import { Empty, Typography, Flex, Skeleton } from 'antd';
import { useIntl } from 'react-intl';

type Props = {
  notifications?: Notification[];
  count?: number;
  setNotificationDrawer: (notification: Notification) => unknown;
  isLoading: boolean;
  onDeleteNotification?: (id: number) => void;
}

export const NotificationList: FC<Props> = ({ notifications, count, setNotificationDrawer, isLoading, onDeleteNotification }) => {
  const { formatMessage: t } = useIntl(); 

  if (isLoading) {
    return (
      <Flex vertical gap={16}>
        <Skeleton.Node style={{ height: 140, width: '100%' }} />
        <Skeleton.Node style={{ height: 140, width: '100%' }} />
        <Skeleton.Node style={{ height: 140, width: '100%' }} />
      </Flex>
    )
  }

  return (
    <>
      {count !== 0 ? (
        <Flex vertical gap={16}>
          {notifications?.map((notification) => (
            <NotificationItem
              id={notification.id}
              title={notification.parameters.title}
              text={notification.parameters.text}
              date={notification.date}
              onClick={() => setNotificationDrawer(notification)}
              onDelete={onDeleteNotification}
              key={notification.id}
            />
          ))}
        </Flex>
      ) : (
        <Empty
          description={
            <Typography.Text>{t ({ id: 'notificationList.no' })}</Typography.Text>
          }
        />
      )}
    </>
  )
}